export function verifiedContactFields(state) {
    return state.otpChannel === "email"
        ? { email: state.patientEmail.trim() }
        : { countryCode: state.countryCode, phoneNumber: state.patientPhone };
}
export function patientEmailFor(state, fallback) {
    return state.otpChannel === "email"
        ? state.patientEmail.trim()
        : fallback || "";
}
export function joinedPhoneOrUndefined(state) {
    if (state.otpChannel === "email")
        return undefined;
    return state.countryCode && state.patientPhone
        ? `${state.countryCode}${state.patientPhone}`
        : undefined;
}
